import * as i0 from "@angular/core";
import * as i1 from "../modal-base/components/modal-base.component";
/**
 * Loading Modal Component
 *
 * Required Attributes:
 * @ loadingText
 * < modalTrigger : object to trigger the opening / closing
 *        { open: true }
 *
 */
export class LoadingModalComponent {
    constructor() {
        this.state = {
            modalOpen: false,
        };
    }
    ngOnChanges(changeObj) {
        if (changeObj.modalTrigger && changeObj.modalTrigger.currentValue !== undefined) {
            this.state.modalOpen = changeObj.modalTrigger.currentValue.open;
        }
    }
}
LoadingModalComponent.ɵfac = function LoadingModalComponent_Factory(t) { return new (t || LoadingModalComponent)(); };
LoadingModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: LoadingModalComponent, selectors: [["ycn-loading-modal"]], inputs: { loadingText: "loadingText", modalTrigger: "modalTrigger" }, features: [i0.ɵɵNgOnChangesFeature], decls: 5, vars: 3, consts: [[3, "extraModalClasses", "open"], [1, "loader"], [1, "loader-message"], [1, "loader-spinner"]], template: function LoadingModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "ycn-modal-base", 0)(1, "div", 1)(2, "div", 2);
        i0.ɵɵtext(3);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(4, "div", 3);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵproperty("extraModalClasses", "modal-sm")("open", ctx.state.modalOpen);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.loadingText);
    } }, dependencies: [i1.ModalBaseComponent], encapsulation: 2 });
